import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    viewHistory: "Ιστορικό παραγγελιών",
    historyHeading: "Ιστορικό παραγγελιών",
    empty: "Δεν έχεις καταχωρημένες παραγγελίες ακόμα.",
    packageMeal: "Γεύμα πακέτου",
    snack: "Σνακ",
    qty: (n: number) => `×${n}`,
    showingMostRecent: (limit: number) => `Εμφανίζονται οι ${limit} πιο πρόσφατες ημέρες παραγγελίας.`,
    pageSummary: (from: number, to: number, total: number) => `${from}–${to} από ${total}`,
    emptyForSchoolYear: "Δεν έχεις παραγγελίες για αυτό το σχολικό έτος.",
    schoolYearLabel: "Σχολικό έτος",
    orderPlaced: (dateLabel: string) => `Παραγγελία · ${dateLabel}`,
};

const en: typeof el = {
    viewHistory: "Order history",
    historyHeading: "Order history",
    empty: "You have no placed orders yet.",
    packageMeal: "Package meal",
    snack: "Snack",
    qty: (n: number) => `×${n}`,
    showingMostRecent: (limit: number) => `Showing the ${limit} most recent order days.`,
    pageSummary: (from: number, to: number, total: number) => `${from}–${to} of ${total}`,
    emptyForSchoolYear: "You have no orders for this school year.",
    schoolYearLabel: "School year",
    orderPlaced: (dateLabel: string) => `Order · ${dateLabel}`,
};

const orderHistoryLangs = { el, en };

export type OrderHistoryStrings = typeof el;

export function useOrderHistoryStrings(): OrderHistoryStrings {
    const [lang] = useContext(langContext);
    return orderHistoryLangs[lang];
}
